import { api } from '../api';

export interface OnboardingCompany {
  name: string;
  regions: Array<{
    name: string;
    locations: string[];
  }>;
}

export interface CompleteOnboardingInput {
  name: string;
  country?: string;
  timezone?: string;
  companies: OnboardingCompany[];
}

export interface CompleteOnboardingResult {
  organizationId: number;
  companies: { name: string; id: number }[];
}

export const onboardingApi = {
  completeOnboarding: (data: CompleteOnboardingInput) =>
    api.post<CompleteOnboardingResult>('/auth/onboarding', data),
};
